<script>
import PageHeader from "../../components/PageHeader.vue";
import RecallsList from "../../components/recalls/RecallsList.vue";
import RecallForm from "../../components/recalls/RecallForm.vue";

export default {
  name: "Index",
  components: { RecallForm, RecallsList, PageHeader },
  data() {
    return {
      tab: null,
      showForm: false,
    };
  },

  computed: {
    userData: function () {
      return this.$store.getters["auth/user"];
    },

    employee: function () {
      return this.userData?.profile || null;
    },

    isApprover: function () {
      return this.employee?.is_approver || false;
    },
  },

  methods: {
    openForm() {
      this.showForm = true;
    },

    closeForm() {
      this.showForm = false;
    },
  },
};
</script>

<template>
  <v-container fluid grid-list-xl>
    <page-header
      title="Leave Recalls"
      :path="$router.currentRoute.meta.breadcrumb"
    />

    <v-card>
      <v-toolbar color="primary" dark>
        <v-toolbar-title>Recalls</v-toolbar-title>

        <v-spacer></v-spacer>

        <v-btn v-if="isApprover" outlined small @click="openForm">
          <v-icon>mdi-plus</v-icon> Raise Recall
        </v-btn>
      </v-toolbar>

      <v-tabs v-model="tab">
        <v-tabs-slider></v-tabs-slider>

        <v-tab v-if="isApprover" href="#supervisor-recalls">
          Raised Recalls
        </v-tab>

        <v-tab href="#my-recalls"> My Recalls </v-tab>
      </v-tabs>

      <v-tabs-items v-model="tab">
        <v-tab-item
          v-if="isApprover"
          key="supervisor-recalls"
          value="supervisor-recalls"
        >
          <RecallsList
            type="supervisor-recalls"
            :employee-no="employee.number"
          />
        </v-tab-item>

        <v-tab-item key="my-recalls" value="my-recalls">
          <RecallsList type="my-recalls" :employee-no="employee.number" />
        </v-tab-item>
      </v-tabs-items>
    </v-card>

    <RecallForm
      :show.sync="showForm"
      :employee-no="employee.number"
      @close="closeForm"
    />
  </v-container>
</template>

<style scoped></style>
